import { useGoogleCallBackMutation, useLoginWithFacebookMutation } from '~/auth/apis/auth.api'

export enum EmailStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  RESENT = 'resent',
  EXPIRED = 'expired',
}

export enum VerifyEmailErrorCode {
  EMAIL_VALIDATION_INVALID = 'emailValidationInvalid',
  EMAIL_VALIDATION_EXPIRED = 'emailValidationExpired',
}

export enum ResendEmailErrorCode {
  TOO_MANY_REQUESTS = 'tooManyRequests',
  EMAIL_CHANGE_REQUIRED = 'emailChangeRequired',
  EMAIL_IN_USER = 'emailInUser',
  USER_ALREADY_VERIFIED = 'userAlreadyVerified',
}

export interface TMathCaptcha {
  challenge: string
  answer: string
}

export enum AuthTypes {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  EMAIL = 'email',
}

export type TAuthTypes = AuthTypes.FACEBOOK | AuthTypes.GOOGLE | AuthTypes.EMAIL

export type LazyQueryResult = ReturnType<typeof useGoogleCallBackMutation | typeof useLoginWithFacebookMutation>
